module.exports = __webpack_public_path__ + "static/media/fb-messenger.ad4afee7.svg";